import React from 'react';
import './Education.css'; // Assume we have a separate CSS file

const Education = () => {
  const approaches = [
    {
      name: 'Pre nursery',
      description: 'Our Pre-Nursery program is designed to nurture and stimulate the youngest minds through a variety of engaging and age-appropriate activities...',
      image: './children-playing-with-toy-garden.jpg',
      color: '#ffe6e6',
      borderColor: '#ffcccc'
    },
    {
      name: 'Nursery',
      description: 'Our Nursery program provides a balanced mix of academic readiness and social-emotional learning through structured play and educational activities..',
      image: './img4.jpg',
      color: '#e6ffe6',
      borderColor: '#ccffcc'
    },
    {
      name: 'LKG',
      description: 'Our LKG program is designed to build a strong foundation in early academics while promoting independence and self-confidence...',
      image: './img5.jpg',
      color: '#fff2e6',
      borderColor: '#ffe6cc'
    },
    {
      name: 'UKG',
      description: 'Our UKG program aims to prepare children for primary school by focusing on advanced academic skills and holistic development. ..',
      image: './img6.jpg',
      color: '#fff9e6',
      borderColor: '#fff2cc'
    }
  ];

  return (
    <div className="education-container">
      {/* <h2>Our Programs</h2> */}
      {approaches.map((approach, index) => (
        <div 
          key={index} 
          className="approach-card"
          style={{backgroundColor: approach.color, borderColor: approach.borderColor}}
        >
          <img src={approach.image} alt={approach.name} />
          <h2>{approach.name}</h2>
          <p>{approach.description}</p>
          <div className="arrow">→</div>
        </div>
      ))}
    </div>
  );
};

export default Education;